import { isIOS, isAndroid } from "react-device-detect";
import { STORE_URLS } from "@/utils/app-download-button";
import { useScrollReveal } from "@/hooks/useScrollReveal";

interface NovaCTAProps {
  setShowQR: (v: boolean) => void;
}

export function NovaCTA({ setShowQR }: NovaCTAProps) {
  const isOnMobile = isIOS || isAndroid;
  const mobileUrl = isIOS ? STORE_URLS.ios : STORE_URLS.android;
  const { ref, visible } = useScrollReveal(0.1);

  return (
    <section className="max-w-[1200px] mx-auto px-6 pb-28 text-center">
      <div
        ref={ref}
        className="relative rounded-3xl border border-[#00d9d9]/20 bg-gradient-to-b from-[#00d9d9]/10 to-transparent p-12 overflow-hidden transition-all duration-700"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(36px)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-[#00d9d9]/5 to-transparent pointer-events-none" />
        <div className="relative z-10">
          <h2 className="text-4xl font-bold text-white mb-3 font-roboto">
            Κατέβασε την εφαρμογή τώρα
          </h2>
          <p className="text-white/60 text-lg mb-8">
            Απόλαυσε όλες τις προσφορές. Είναι <span className="text-[#00d9d9] font-semibold">ΔΩΡΕΑΝ!</span>
          </p>
          {isOnMobile ? (
            <a href={mobileUrl} target="_blank" rel="noopener noreferrer">
              <button className="hover:scale-105 transform transition-all duration-200 cursor-pointer font-bold px-12 py-4 rounded-full bg-[#00d9d9] text-black text-sm font-press-start">
                Κατέβασε την Εφαρμογή
              </button>
            </a>
          ) : (
            <button
              onClick={() => setShowQR(true)}
              className="hover:scale-105 transform transition-all duration-200 cursor-pointer font-bold px-12 py-4 rounded-full bg-[#00d9d9] text-black text-sm font-press-start"
            >
              Κατέβασε την Εφαρμογή
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
